<div *ngIf="_showTutorialDim" [ngClass]="{'screen-dim': isModalIntroduction()}"></div>
<div *ngIf="!isModalIntroduction()">
    <div [hidden]="hideCommingLesson" [class]="hideCommingLesson? '' : 'mb-4 mb-md-5'" [ngClass]="{tutorial: _introductionState == IntroductionState.FutureLesson}">
      <app-student-comming-lesson-list (stateEvent)="onCommingLessonEvent($event)" [studentId]="studentId" [_introductionState]="_introductionState"></app-student-comming-lesson-list>
    </div>
  <div  [hidden]="hideStarterOffers" >
    <div class="card mb-4 mb-md-5 bg-accent bg-smoke text-white bg-cover">
      <div class="card-body">
        <app-student-starters-offer (stateEvent)="onStarterOfferEvent($event)" [studentId]="studentId"></app-student-starters-offer>
      </div>
    </div>
  </div>
  <app-student-missing-data-box [studentId]="studentId"></app-student-missing-data-box>
  <div class="row">
    <div class="col-12">
      <!-- MY PROGRESS -->
      <div class="card mb-4 mb-md-5">
        <app-student-context-based-progress (reserveProvaEvent)="reserveProvaClicked()"
          [langCode]="langCode" [studentId]="studentId" [isTutorial]="_introductionState == IntroductionState.ReserveProva" [isShowReserveProva]="isShowReserveProva()">
        </app-student-context-based-progress>
      </div>
      <!-- MY CREDITS  -->
      <div class="card mb-4 mb-md-5" id="credits">
          <app-student-credits (freeCreditEvent)="getFreeCredit()"
            [langCode]="langCode" [studentId]="studentId" [_introductionState]="_introductionState"></app-student-credits>
      </div>
      <!-- FUTURE LESSONS -->
      <div class="card mb-4 mb-md-5" id="futureLess">
        <div class="card-header d-flex align-items-center">
          <span i18n="@@student-dashboard.future-lessons-box.title">Future Lessons</span>
          <span *ngIf="upcomingLessons?.getTotalResults()" class="badge bg-primary ms-3">{{upcomingLessons.getTotalResults()}}</span>
          <app-tooltip class="ms-auto">
            <content>
              <p class="mb-0" i18n="@@induction-box.tooltip-future-lessons">This is a list of lessons that you have booked. You can cancel a booking and recover a credit if there's over 12 hours left until the booked lesson time.</p>
            </content>
          </app-tooltip>
        </div>
        <div class="card-body" [ngClass]="{'py-0': futureLoading}">
          <app-student-lessons
            #upcomingLessons
            (lessonDetailsEvent)="openLessonDetails($event)"
            componentRole="student"
            [langCode]='langCode'
            [lessonType]='lessonTypes.Upcomming'
            [studentId]="studentId"
          ></app-student-lessons>
        </div>
        <div class="card-footer">
          <app-pagination [pageableComponent]="upcomingLessons"></app-pagination>
        </div>
      </div>

      <!-- EXERCISES -->
        <div class="card mb-4 mb-md-5 mt-2"
          id="exercises"
          >
          <div id="tut-cspa" class="card-header d-flex justify-content-between align-items-center">
            <span i18n="@@student-dashboard.exercises-box.title" class="mb-0 me-3">Exercises</span>
            <app-tooltip class="ms-auto">
              <content>
                <p class="mb-0" i18n='@@induction-box.tooltip-exercises'>Do the exercises between lessons to practise what you've learned and consolidate your skills. Important: In browser settings, give Callan Online permission to open popups.</p>
              </content>
            </app-tooltip>
          </div>
            <app-exercise-set-host [setPath]="getCspaSet()" ></app-exercise-set-host>
        </div>

      <!-- PAST LESSONS -->
      <div class="card mb-4 mb-md-5"
        id="pastLess">
        <div class="card-header d-flex align-items-center">
          <span i18n="@@student-dashboard.past-lessons-box.title">Past lessons</span>
          <span *ngIf="pastLessons.getTotalResults()" class="badge bg-primary ms-3">{{pastLessons.getTotalResults()}}</span>
          <app-tooltip class="ms-auto">
            <content>
              <p class="mb-0" i18n='@@induction-box.tooltip-past-lessons'>All bookings you made in the past, including lessons that have taken place and cancelled bookings.</p>
            </content>
          </app-tooltip>
        </div>
        <div class="card-body pt-0">
          <app-student-lessons #pastLessons (lessonDetailsEvent)="openLessonDetails($event)" componentRole="student" [langCode]='langCode' [lessonType]='lessonTypes.Past' [studentId]="studentId"></app-student-lessons>
        </div>
        <div class="card-footer" *ngIf="!pastLoading">
          <app-pagination [pageableComponent]="pastLessons"></app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- modal for tutorial -->
<app-modal #initialModal [isFaded]="false" [classes]="'bg-secondary'">
  <div class="modal-content p-4">
    <div class="modal-body">
      <div *ngIf="_introductionState == IntroductionState.Course">
        <p class="mb-3 mb-sm-5" i18n="Ask student for language to learn@@induction-box.preffered-course-question">What course do you want to take?</p>
        <div class="row text-center mb-3 mb-sm-5 g-2 row-cols-2 justify-content-center row-cols-sm-3">
          <div class="col" *ngFor="let langCode of _courseDialog.productMapper.activeLangCodes">
              <div class="d-flex flex-column justify-content-around align-items-center course-select py-2 rounded h-100"
                [ngClass]="{'bg-primary': _courseDialog.productCode == langCode}"
                (click)="_courseDialog.productCode = langCode">
                <label class="fw-bold" i18n="@@common.langName">{_courseDialog.productMapper.mapLangCodeToLangName(langCode), select, English {English} Spanish {Spanish} Business English {Business English} English For Children {English For Children}}</label>
                <input class="form-check-input" type="radio" [checked]="langCode == _courseDialog.productCode"
                >
            </div>
          </div>
        </div>
        <div class="d-flex flex-column flex-sm-row">
          <div class="d-flex ms-auto">
            <button type="button" class="btn btn-primary btn-bubble rounded-pill ms-3" (click)="updateCourse()"
                    i18n="@@common.Next" [disabled]="!_courseDialog.productCode">Next
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-modal>

<app-modal #inviteModal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 i18n="New Callan Online modal title@@student-dashboard.invite-modal.title">A new version of Callan Online is available</h5>
      <button type="button" class="btn-close" (click)="inviteModal.hide()"  aria-label="Close"></button>
    </div>
    <div class="modal-body" i18n="New Callan Online modal body@@student-dashboard.invite-modal.body">
      We’ve created an improved version of your Callan Online interface. You can start using it now or keep using the current version for now. If you go to new Callan Online now, you can still switch back to the old interface if you want.
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="dissmissInvitationModal()"
        i18n="@@common.later">Later</button>
      <button type="button" class="btn btn-primary" (click)="goToNewCallan()"
        i18n="New Callan Online modal button@@student-dashboard.invite-modal.button">Go to new Callan Online</button>
    </div>
  </div>
</app-modal>
